import { reachActionType } from '../utils/constants';

export type Dispatch = (action: any) => void;

export type IHookState<ResponseType> = ResponseType | undefined;

export enum StatusAPI {
  IDLE = 'idle',
  LOADING = 'loading',
  FULFILLED = 'suceeded',
  REJECTED = 'failed',
  CLEARERROR = 'clear',
}

export enum reachContractActionType {
  OPTIN = 'opt-in',
  DEPOSIT = 'deposit',
}
export type Player2AcceptResponse = {
  wagerAmount: number | null;
  isPromotionalRewards: boolean;
  notes: string | null;
  origin: string | null;
  status: string;
  matchId: string | null;
  _id: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  __v: number | null;
  url: string | null;
  appId: string | null;
  isNotified: boolean;
  reward: {
    gameReward: null | number;
    promotionReward: null | number;
  };
  users: {
    color: 'white' | 'black';
    isSigned: boolean;
    url: string;
    userId: string;
    username: string;
    gameReward: null | number;
    promotionReward: null | number;
  }[];
  result?: {
    black: number;
    white: number;
    winner: string;
  };
};

export enum GameTypeEnum {
  chess = 'chess',
}

export type sendWagerData = {
  wagerAmount: number;
  username: string;
  userId: string;
  game: GameTypeEnum;
};
export type GenerateLinkAPIResponse = {
  url: string;
  gameId: string;
};
export type Player2Accept = {
  username: string;
  userId: string;
  gameId: string | string[] | undefined;
  status: string;
};
export type SignContractStatus = {
  userId: string;
  gameId: string;
};
export type AttachPlayerPayload = {
  account: any;
  wager: number | null;
  matchId: string | null;
  doOptIn: boolean;
};
export type TournamentGameData = {
  user_id: string;
  game_id: string;
};
export type ReachAction = {
  type: reachActionType | reachContractActionType;
  status: any;
  payload?: any;
};
export type ReachDispatch = (action: ReachAction) => void;
